import './styles.css';

// fullPage: ocupa la pantalla mientras carga una página completa, para que el footer no
// quede a la vista y luego salte hacia abajo al llegar el contenido (CLS).
const Preloader = ({ fullPage = false }) => {
    return (
        <section
            id='productsSection'
            style={{
                height: fullPage ? '100vh' : '50vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <div className='lds-ring'>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <p className='productTitle'>Loading...</p>
        </section>
    );
};

export default Preloader;
